import axios from 'axios'
import MbxClient from '@mapbox/mapbox-sdk';

const $cfg = {}

$cfg.API = axios.create({
  baseURL: process.env['VUE_APP_SERVICE_API_URL'],
});


// $cfg.mbx = MbxClient({ accessToken: process.env['VUE_APP_MAPBOX_PK'] });

// $cfg.API.interceptors.response.use(res => res, err => {
//   console.log(err.response);
//   if(err.response.status >= 500) {
//     app.$vs.notify({
//       title: 'Oops :(',
//       text: 'Server error',
//       color: 'danger',
//     });
//   }
//   return Promise.reject(err);
// });

export default $cfg;
